module.exports = __webpack_public_path__ + "static/img/service-03.5c144a5c.png";